var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex justify-content-center no-data"})
}
var staticRenderFns = []

export { render, staticRenderFns }